import { useEffect } from 'react'
import { Drawer, Typography, Button } from '@evocolabs/orkaui'
import { Box } from '@mui/material'
import { useRouter } from 'next/router'
import React from 'react'
import imgs from '../data/imgs'
import style from '@/pages/scss/OrkaTwo.module.scss'
import { disableBack, recoverDisableBack } from '@/src/utils/historyImprove'

const { serviceImgs } = imgs
const data = {
  title: `What to Expect After Receiving Your Orka Two`,
  services: [
    {
      title: 'Welcome Call',
      subTitle:
        'Our hearing experts will walk you through the basics of hearing aids and hearing health.',
      src: serviceImgs[1]
    },
    {
      title: 'Unlimited Remote Care',
      subTitle:
        'Schedule virtual consultations to discuss hearing concerns and issues with daily use. Get remote adjustments and fine-tuning based on personal needs.',
      src: serviceImgs[0]
    },
    {
      title: 'Orka Health App',
      subTitle:
        'One-stop access to everything you need. Onboarding tutorial, real-time adjust and set up hearing aids, and connect with hearing professionals, any time anywhere.',
      src: serviceImgs[2]
    },
    {
      title: 'Complimentary In-App Hearing Screening',
      subTitle:
        'The in-app hearing screening will help you receive personalized assessments and adjustments at home without extra equipment while auto-syncing and updating your hearing profile.',
      src: serviceImgs[3]
    }
  ]
}

const RenderServiceOne = function ({ title, subTitle, src }) {
  return (
    <Box display="flex" flexDirection="column" mb="24px" width="100%">
      <Typography variant="T2" mb="8px">
        {title}
      </Typography>
      <Typography variant="body3" mb="16px">
        {subTitle}
      </Typography>
      <Box flex="1">
        <img src={src} style={{ width: '100%', height: '100%' }} alt={title} />
      </Box>
    </Box>
  )
}
const Service = function ({ open, onClose }) {
  const router = useRouter()
  useEffect(() => {
    if (open) {
      disableBack(() => {
        recoverDisableBack()
        onClose()
      })
    }
  }, [open])

  return (
    <>
      <Drawer
        open={open}
        onClose={onClose}
        disableMobSizeAdjustment={true}
        sx={{
          top: { xs: '48px', dl: '0' },
          '>.MuiPaper-root': { top: { xs: '48px', dl: '0' } },
          ' .orkaui-drawer-container': {
            paddingBottom: '16px',
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
          }
        }}
      >
        <Box display="flex" flexDirection="column" height="100%">
          <Typography variant="h3">{data.title}</Typography>
          <Box mt="24px" className={style['service-img-box']}>
            {data.services.map((d, index) => (
              <RenderServiceOne
                key={index}
                title={d.title}
                subTitle={d.subTitle}
                src={d.src}
              />
            ))}
            <Button
              id="product-service-orkaCare"
              handleClick={() => {
                router.push('/OrkaCare')
              }}
            >
              Explore OrkaCare
            </Button>
          </Box>
        </Box>
      </Drawer>
    </>
  )
}

export default Service
